import { toaster } from "@dk.onlinefundraising/vue-utils/src/helpers/OfToaster"
import { provide, ref } from "vue"

export function provideErrorMessageContext() {
    const errorMessage = ref()

    function alertError(error) {
        toaster.error(error)
        errorMessage.value = error
    }

    provide('errorMessageContext', { errorMessage, alertError })
}